export interface NavigationItemStorageInterface {
    title: string;
    icon: string;
    defaultRoute?: string;
    // Optional sub-items – renders as expandable group when present
    children?: NavigationItemStorageInterface[];
}

export const NavigationItemStorage: NavigationItemStorageInterface[] = [{
    title: 'Kundenübersicht',
    icon: 'mdi-account-group',
    defaultRoute: 'customers_view',
}, {
    title: 'Interaktive Karte',
    icon: 'mdi-map',
    defaultRoute: 'map_view',
}, {
    title: 'Bestandsaufnahme Tool',
    icon: 'mdi-wrench',
    defaultRoute: 'maintenance_tool_view',
}, {
    title: 'Antriebsübersicht',
    icon: 'mdi-pen',
    defaultRoute: 'actuator_overview_view',
}, {
    title: 'Reports',
    icon: 'mdi-chart-bar',
    children: [
        { title: 'Dashboard / Übersicht',                icon: 'mdi-view-dashboard-outline', defaultRoute: 'reports_overview_view' },
        { title: 'Maschinen-/Antriebsansicht',     icon: 'mdi-tag-multiple-outline',    defaultRoute: 'reports_labels_view' },
        { title: 'Projekte',                icon: 'mdi-folder-outline',          defaultRoute: 'reports_projects_view' },
        { title: 'Kunden',               icon: 'mdi-account-multiple-outline',defaultRoute: 'reports_customers_view' },
        { title: 'Technik / Engineering', icon: 'mdi-engine-outline',             defaultRoute: 'reports_technical_view' },
    ],
},];
